import { PartyService } from 'src/app/services/api/party/party.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LevelObject } from 'src/app/models/tree/level-object.model';
import { ConfigService } from 'src/app/services/api/config/config.service';
import { OrderDetailsGeneralObject } from 'src/app/models/orders/order-details-general/order-details-general-object.model';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderService } from 'src/app/services/api/orders/specific-order/order.service';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';
import { OrdersService, OrderSummary, OrderTree } from 'src/app/services/api/orders/orders.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { Title } from "@angular/platform-browser";

@Component({
  selector: 'app-specific-order',
  templateUrl: './specific-order.component.html',
  styleUrls: ['./specific-order.component.css']
})
export class SpecificOrderComponent implements OnInit, OnDestroy {

  tree: OrderTree;
  params: any;
  summary: OrderSummary;
  isps: any[];

  backUrl = '/provision/orders/search';
  treeCardSubscription: Subscription;
  previousOrderId: string;
  previousType: LevelObject;
  item: ItemObject;
  url: Router;
  isCancellable: boolean;
  generalInfo: OrderDetailsGeneralObject;
  activatedRouteSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute, private orderService: OrderService, private configService: ConfigService,
    private ordersService: OrdersService, private breadcrumbsService: BreadcrumbsService,
    private partyService: PartyService, private notificationsService: NotificationsService,
    private titleService: Title) {
  }

  ngOnInit(): void {
    this.isCancellable = false;
    this.item = ItemObject.create();
    this.generalInfo = OrderDetailsGeneralObject.create();

    this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (this.titleService.getTitle().includes(" - ")) {
        this.titleService.setTitle(params.id + " - " + this.titleService.getTitle().split(" - ")[1]);
      }
      else {
        this.titleService.setTitle(params.id + " - " + this.titleService.getTitle());
      }
      this.params = params;
      this.loadOrder(false);
    });
  }

  loadOrder(isReload: boolean) {
    let hasError = false;
    this.ordersService.getOrderTree(this.params.id).subscribe(
      (data) => {
        if (data.children[0] && data.children[0].children[0]) {
          data.children[0].children[0].children.sort((x, y) => {
            return y.name > x.name ? -1 : 1;
          });
        }
        this.tree = data;
      },
      (error) => {
        hasError = true;
      }
    );
    if (this.params.type && this.params.type === 'product') {
      this.ordersService.getProductOrderSummary(this.params.map).subscribe(
        (data) => {
          this.summary = data;
          this.summary.isReload = isReload;
        },
        (error) => {
          hasError = true;
        }
      );
    } else if (this.params.type && this.params.type !== 'crm') {
      this.ordersService.getServiceOrderSummary(this.params.map).subscribe(
        (data) => {
          this.summary = data;
          this.summary.isReload = isReload;
        },
        (error) => {
          hasError = true;
        }
      );
    } else {
      this.summary = {
        externalId: this.params.id,
        type: {
          name: 'CRM',
        }
      }
    };
    this.partyService.getCustomers().subscribe(
      (data) => {
        this.isps = data;
      },
      (error) => {
        hasError = true;
      }
    );
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Órdenes', url: 'provision/orders/search' },
            { title: 'Detalle de orden', url: `provision/orders/detail`, params: { id: this.params.id } }
          ]
      }
    );

    if (isReload) {
      if (hasError) {
        this.notificationsService.showNotification(
          'La información relativa a la orden no se ha recargado correctamente', NotificationLevel.ERROR
        );
      } else {
        this.notificationsService.showNotification(
          'La información relativa a la orden se ha recargado correctamente', NotificationLevel.SUCCESS
        );
      }
    }

  }

  ngOnDestroy() {
    this.activatedRouteSubscription.unsubscribe();
  }

  /*

  private isRightTab(item: ItemObject): boolean {
    return item.tab.equals(TabObject.GENERAL_TAB) || item.tab.equals(TabObject.PRODUCT_TAB)
      || item.tab.equals(TabObject.SERVICE_TAB) || item.tab.equals(TabObject.PROCESSES_TAB)
      || item.tab.equals(TabObject.SITES_TAB);
  }

  private isNotLoadedOrder(item: ItemObject, generalInfo: OrderDetailsGeneralObject): boolean {
    return !generalInfo.isFetched() || generalInfo.getOrderId() !== item.orderId;
  }

  */

  reloadOrder() {
    this.loadOrder(true);
  }

  isCancelState(generalInfo: OrderDetailsGeneralObject): boolean {
    return generalInfo.getStatus().equals(OrderStatusObject.CANCELLED_STATUS)
      || generalInfo.getStatus().equals(OrderStatusObject.CANCELLING_STATUS)
      || generalInfo.getStatus().equals(OrderStatusObject.CANCELLING_HELD_STATUS);
  }


}